<template>
  <div>
    <header
      class="masthead"
      :style="{ backgroundImage: 'url(' + require('@/assets/images/backgrounds/home.jpg') + ')' }"
    >
      <div class="masthead-overlay"></div>
      <div class="container h-100">
        <div class="row h-100 align-items-center">
          <div class="col-12 text-center">
            <h1 class="font-weight-light">Make Your Waiheke Adventure Amazing With Us</h1>
            <p
              class="lead"
            >Come and experience a range of adventure and fun activities during all seasons of the year</p>
          </div>
        </div>
      </div>
    </header>

    <!-- 
Be part of our adventure
Book now for an experience you will not forget.
    -->

    <section class="pt-5">
      <div class="container">
        <div class="row justify-content-center pb-4">
          <div class="col-md-12 heading-section text-center">
            <h2 class="mb-4">Water Activities</h2>
          </div>
        </div>
        <div class="row">
          <HomeActivity v-for="(activity) in activities.waterActivities" :key="activity.name"
                        v-bind:name="activity.name" 
                        v-bind:desc="activity.desc" 
                        v-bind:price="activity.price" 
                        v-bind:imageFilename="activity.galleryImage[0]" 
                        activityTypeLink="water-activities"
                        v-bind:activityLink="activity.id" />
        </div>
      </div>
    </section>

    <section class="pt-5">
      <div class="container">
        <div class="row justify-content-center pb-4">
          <div class="col-md-12 heading-section text-center">
            <h2 class="mb-4">Land Activities</h2>
          </div>
        </div>
        <div class="row">
          <HomeActivity v-for="(activity) in activities.landActivities" :key="activity.name"
                        v-bind:name="activity.name" 
                        v-bind:desc="activity.desc" 
                        v-bind:price="activity.price" 
                        v-bind:imageFilename="activity.galleryImage[0]" 
                        activityTypeLink="land-activities"
                        v-bind:activityLink="activity.id" />
        </div>
      </div>
    </section>

    <section class="pb-5">
      <div class="container mt-5 mb-5">
        <div class="row d-flex flex-md-row mt-5 activity-spacer">
          <div class="col-md-6 pl-md-5 py-5">
            <div class="row justify-content-start pb-3">
              <div class="col-md-12 activity-heading-section">
                <h2 class="mb-4">Our Photos</h2>
                <p>Check out our <router-link to="/gallery">photo gallery</router-link> for some of the moments and memories we have captured on our adventures.</p>
              </div>
            </div>
          </div>
          <div class="col-md-6 order-md-last">
            <div class="activity-image" :style="{ backgroundImage: 'url(' + require('@/assets/images/gallery-home.jpg') + ')' }" ></div>
          </div>
        </div>
        <div class="row d-flex flex-md-row mt-5 activity-spacer">
          <div class="col-md-6 order-md-last pl-md-5 py-5">
            <div class="row justify-content-start pb-3">
              <div class="col-md-12 activity-heading-section">
                <h2 class="mb-4">Be part of our story</h2>
                <p>We would love to collaborate and share pictures from our adventures. Follow us on Facebook and feel free to share your experience.</p>
                <p>
                  <a
                    class="btn btn-primary py-2 px-5"
                    href="https://www.facebook.com/WaihekeAdventureCentre/"
                    target="_blank"
                  >Share Photos</a>
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="embed-responsive embed-responsive-1by1">
              <iframe
                class="embed-responsive-item"
                :src="setFacebookURL()"      
                style="border:none;overflow:hidden"
                scrolling="no"
                frameborder="0"
                allowtransparency="true"
                allow="encrypted-media"
              ></iframe>
            </div>
          </div>
        </div>
        <div class="row d-flex flex-md-row mt-5 activity-spacer">
          <div class="col-md-6 pl-md-5 py-5">
            <div class="row justify-content-start pb-3">
              <div class="col-md-12 activity-heading-section">
                <h2 class="mb-4">About Us</h2>
                <p>Ross started his Kayaking business more than 30 years ago Established 1987 after running Kayak adventures in Auckland Devonport and the Hauraki Gulf island of Great Barrier. Ross was initially encouraged by the Ferry company Fullers, to start offering Waiheke experiences at a time when the visitor industry was in its infancy <router-link to="/about-us">read more</router-link>.</p>
                
              </div>
            </div>
          </div>
          <div class="col-md-6 order-md-last">
            <div class="activity-image" :style="{ backgroundImage: 'url(' + require('@/assets/images/about-home.jpg') + ')' }" ></div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div style="height: 400px">
        <iframe width="100%" height="100%" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3195.5198231985846!2d174.99111051581798!3d-36.78208518348671!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6d72cbc42f3c1761%3A0xea7c2e43882f3fe3!2sWaiheke%20Adventure%20Centre!5e0!3m2!1sen!2scz!4v1591545958916!5m2!1sen!2scz"></iframe>
      </div>
    </section>

  </div>
</template>

<style lang="scss">
.lead {
  color: #f06a29;
  background-color: #292929;
  padding: 15px;
  opacity: 0.9;
}

p.lead {
  font-weight: 400;
  font-size: 20px;
  line-height: 1.5rem;
}

.heading-section h2 {
  font-size: 40px;
  font-weight: 600;
  line-height: 1.4;
}

</style>

<script>
import Activities from "../json/data.json";
import HomeActivity from "@/components/HomeActivity.vue";
import { setFacebookURL } from "../helpers/helpers.js";

export default {
  name: "home",
  components: {
    HomeActivity
  },
  data: function() {
    return {
      activities: Activities
    };
  },
  methods: {
      setFacebookURL
  }
};
</script>